const GA_MEASUREMENT_ID = 'G-J2H7NKG1ED';

export default GA_MEASUREMENT_ID;
